import EditableAmount from "@components/smart/selectionTableView/EditableAmount";
import { TSmartODataTableStorage } from "@components/smart/smartTable/SmartODataTableBase";
import { ICellValueObject } from "@components/table";
import { ICurrencyEntity } from "@odata/GeneratedEntityTypes";
import { IFormatOptions } from "@odata/OData.utils";
import React from "react";

import { ITableStorageDefaultCustomData } from "../../../model/TableStorage";
import { formatCurrency } from "../../../types/Currency";

export interface IPairedItem {
    TransactionAmount: number;
    TransactionCurrency: ICurrencyEntity;
    ExchangeRatePerUnit: number;
    Amount: number;
}

export interface ISelectionWithEditableAmountCustomTableData extends ITableStorageDefaultCustomData {
    pairedDialogItemId: string;
    pairedItems: Record<string, IPairedItem>;
}

export const editableAmountLinkFormatter = (args: IFormatOptions): ICellValueObject => {
    const { item, storage, bindingContext } = args;
    const tableStorage = storage as TSmartODataTableStorage<ISelectionWithEditableAmountCustomTableData>;

    const { tableAPI } = tableStorage;
    const { activeRows } = tableAPI.getState();

    const rowId = bindingContext.getRootParent().toString();
    const isRowSelected = activeRows.has(rowId);

    const { pairedItems } = tableStorage.getCustomData();
    const pairedItem = pairedItems?.[rowId];

    const CurrencyCode = item.TransactionCurrencyCode ?? item.TransactionCurrency?.Code;
    const formattedValue = formatCurrency(pairedItem?.TransactionAmount ?? 0, CurrencyCode);

    return {
        tooltip: formattedValue,
        value: (
                <EditableAmount storage={tableStorage}
                                value={formattedValue}
                                rowId={rowId}
                                isRowSelected={isRowSelected} />
        )
    };
};